export enum DashboardResourceTypeEnum {
  DEVELOPMENT_STRATEGY = 'development_strategy',
  INTERNATIONAL_COOPERATION = 'international_cooperation',
  FIVE_INITIATIVE = 'five_initiative',
}
